export const LOAD_PROJECTS = 'LOAD_PROJECTS';
export const LOGOUT = 'LOGOUT';
export const VALIDATE_BUTTON_PROJECT = 'VALIDATE_BUTTON_PROJECT';
export const TOGGLE_PROJECT = 'TOGGLE_PROJECT_BUTTON';
export const INITIAL_DASHBOARD = 'INITIAL_DASHBOARD';
export const DISABLED_BUTTON = 'DISABLED_BUTTON';
export const CLEAN_DASHBOARD_EMPLOYEE_PROJECT = 'CLEAN_DASHBOARD_EMPLOYEE_PROJECT';
export const FIND_SOLUTIONS_PROCESSED = 'FIND_SOLUTIONS_PROCESSED';
